import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import ChoiceChips from 'components/Form/choiceChips';
import FilterDrawerShell from 'components/Form/filterDrawerShell';
import FilterSection, { FilterField } from 'components/Form/filterSection';
import FilterSelect from "components/Form/filterSelect";
import { countActive, filterValueOf, resolveMultiValue } from 'components/Form/filterValues';
import { leaveStatusOptions } from 'utils/constants';

const SECTION_KEYS = {
  request: ["approval_status", "leave_type"],
  people: ["company_user", "department", "cost_center", "current_approver"],
};

const LeaveFilterDrawer = ({
    handleFilterDrawer,
    showFilterDrawer,
    handleFilterChange,
    filters,
    handleApplyFilter,
    filterLoading,
    leaveTypes,
    handleClearAll,
    isFilterDirty
}) => {
  const {
    userData, userDataLoading,
    department, departmentLoading,
    costCenter, costCenterLoading,
    currentApprovers, currentApproversLoading
  } = useSelector((state) => state.common);
  const [userDataOption, setUserDataOption] = useState([]);
  const [departmentOption, setDepartmentOption] = useState([]);
  const [costCenterOption, setCostCenterOption] = useState([]);
  const [currentApproverOption, setCurrentApproverOption] = useState([]);

  useEffect(() => {
    setUserDataOption((userData || []).map(item => ({ label: `${item.first_name} ${item.last_name || ""}`.trim(), value: item.id, emp_no: item.emp_no })));
    setDepartmentOption((department || []).map(item => ({ label: item.name, value: item.id })));
    setCostCenterOption((costCenter || []).map(item => ({ label: item.name || item.code, value: item.id, code: item.code })));
    setCurrentApproverOption((currentApprovers || []).map(item => ({ label: item.emp_no ? `${item.name} (${item.emp_no})` : item.name, value: item.id })));
  }, [userData, department, costCenter, currentApprovers]);

  const valueOf = (key) => filterValueOf(filters, key);
  const leaveTypeOptions = leaveTypes || [];

  return (
    <FilterDrawerShell
      open={showFilterDrawer}
      onClose={handleFilterDrawer}
      activeCount={countActive(filters, Object.values(SECTION_KEYS).flat())}
      onClearAll={handleClearAll}
      onApply={handleApplyFilter}
      applying={filterLoading}
      applyDisabled={!isFilterDirty}
    >
      <FilterSection title="Request" count={countActive(filters, SECTION_KEYS.request)}>
        <FilterField label="Approval status" hint="default: pending">
          <ChoiceChips ariaLabel="Approval status" options={leaveStatusOptions} value={valueOf("approval_status")} onChange={(option) => handleFilterChange(option, "approval_status")} />
        </FilterField>
        <FilterField label="Leave type" hint="one or more" htmlFor="filter-leave-type">
          <FilterSelect inputId="filter-leave-type" isMulti={true} checkboxMenu={true} maxVisibleValues={2} menuPosition="fixed" isClearable={true} onChange={e=>{handleFilterChange(e, "leave_type")}} optionLabel={"label"} optionValue={'value'} options={leaveTypeOptions} value={resolveMultiValue(valueOf("leave_type"), leaveTypeOptions)} placeholder={"Any"} noOptionsLabel={"leave types"}/>
        </FilterField>
      </FilterSection>

      <FilterSection title="People" count={countActive(filters, SECTION_KEYS.people)}>
        <FilterField label="Employee" hint="one or more" htmlFor="filter-leave-user">
          <FilterSelect inputId="filter-leave-user" isMulti={true} checkboxMenu={true} maxVisibleValues={2} menuPosition="fixed" isClearable={true} onChange={e=>{handleFilterChange(e, "company_user")}} optionLabel={"label"} optionValue={'value'} options={userDataOption} isLoading={userDataLoading} value={resolveMultiValue(valueOf("company_user"), userDataOption)} placeholder={"Any"}/>
        </FilterField>
        <FilterField label="Department" hint="one or more" htmlFor="filter-leave-department">
          <FilterSelect inputId="filter-leave-department" isMulti={true} checkboxMenu={true} maxVisibleValues={2} menuPosition="fixed" isClearable={true} onChange={e=>{handleFilterChange(e, "department")}} optionLabel={"label"} optionValue={'value'} options={departmentOption} isLoading={departmentLoading} value={resolveMultiValue(valueOf("department"), departmentOption)} placeholder={"Any"} noOptionsLabel={"departments"}/>
        </FilterField>
        <FilterField label="Cost center" hint="one or more" htmlFor="filter-leave-cost-center">
          <FilterSelect inputId="filter-leave-cost-center" isMulti={true} checkboxMenu={true} maxVisibleValues={2} menuPosition="fixed" isClearable={true} onChange={e=>{handleFilterChange(e, "cost_center")}} optionLabel={"label"} optionValue={'value'} options={costCenterOption} isLoading={costCenterLoading} value={resolveMultiValue(valueOf("cost_center"), costCenterOption)} placeholder={"Any"} noOptionsLabel={"cost centers"}/>
        </FilterField>
        <FilterField label="Current approver" hint="one or more" htmlFor="filter-leave-approver">
          <FilterSelect inputId="filter-leave-approver" isMulti={true} checkboxMenu={true} maxVisibleValues={2} menuPosition="fixed" isClearable={true} onChange={e=>{handleFilterChange(e, "current_approver")}} optionLabel={"label"} optionValue={'value'} options={currentApproverOption} isLoading={currentApproversLoading} value={resolveMultiValue(valueOf("current_approver"), currentApproverOption)} placeholder={"Any"} noOptionsLabel={"approvers"}/>
        </FilterField>
      </FilterSection>
    </FilterDrawerShell>
  );
};
export default LeaveFilterDrawer;
